var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6705 0.454505C9.10983 0.893845 9.10983 1.60616 8.6705 2.0455L2.71599 8L8.6705 13.9545C9.10983 14.3938 9.10983 15.1062 8.6705 15.5455C8.23116 15.9848 7.51884 15.9848 7.0795 15.5455L0.329505 8.7955C-0.109835 8.35616 -0.109835 7.64384 0.329505 7.2045L7.0795 0.454505C7.51884 0.015165 8.23116 0.015165 8.6705 0.454505Z",
    fill: "#284FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeftBlue);
export default __webpack_public_path__ + "static/media/ic-arrow-left-blue.fe0928fc5629b0fa8db753e9b0d13d76.svg";
export { ForwardRef as ReactComponent };